import auth from 'libs/auth'
import { Component } from 'preact'
import { Router } from 'preact-router'
import { withGTM } from 'react-tag-manager'
import Account from 'routes/account'
import Apps from 'routes/apps'
import Auth from 'routes/auth'
import ChannelPreviews from 'routes/channel-previews'
import CheckoutApp from 'routes/checkout-app'
import DvrApp from 'routes/dvr-app'
import ExternalUrl from 'routes/external-url'
import Games from 'routes/games'
import Live from 'routes/live'
import RadiosApp from 'routes/radios-app'
import Recommendations from 'routes/recommendations'
import Search from 'routes/search'
import Settings from 'routes/settings'
import SupportApp from 'routes/support-app'
import VideoLibraryApp from 'routes/video-library-app'
import YouTube from 'routes/youtube'

class AppRouting extends Component {
  handleRoute = e => {
    const { GTM } = this.props
    if (GTM.api) {
      const data = {
        event: 'pageview',
        url: e.url
      }
      if (auth.isLoggedIn()) {
        data['userId'] = auth.getUsername()
      }
      GTM.api.trigger(data)
    }
  }

  getRouteProps = routeName => {
    if (this.props.defaultRoute === routeName) {
      return {
        default: true
      }
    } else {
      return true
    }
  }

  render() {
    return (
      <Router onChange={this.handleRoute}>
        <ChannelPreviews
          path={`${__webpack_public_path__ || '/'}previews`}
          {...this.getRouteProps('previews')}
        />
        <Recommendations
          path={`${__webpack_public_path__ || '/'}recommendations`}
          {...this.getRouteProps('recommendations')}
        />
        <Account path={`${__webpack_public_path__ || '/'}account/:tab`} />
        <Account
          path={`${__webpack_public_path__ || '/'}account/`}
          {...this.getRouteProps('account')}
        />
        <Auth path={`${__webpack_public_path__ || '/'}auth/:action`} />
        <CheckoutApp
          path={`${__webpack_public_path__ || '/'}checkout/:action?`}
          {...this.getRouteProps('checkout')}
        />
        <DvrApp
          path={`${__webpack_public_path__ || '/'}dvr/:action?/:id?`}
          {...this.getRouteProps('dvr-library')}
        />
        <Live
          path={`${__webpack_public_path__ || '/'}live`}
          {...this.getRouteProps('live')}
        />
        <VideoLibraryApp
          path={`${__webpack_public_path__ || '/'}video-library`}
          {...this.getRouteProps('video-library')}
        />
        <VideoLibraryApp
          path={`${__webpack_public_path__ || '/'}video-category/:categoryId`}
        />
        <VideoLibraryApp
          path={`${__webpack_public_path__ || '/'}video/:action/:videoId`}
        />
        <SupportApp
          path={`${__webpack_public_path__ ||
            '/'}support/:action?/:action1?/:action2?`}
          {...this.getRouteProps('support')}
        />
        <Search
          path={`${__webpack_public_path__ || '/'}search`}
          {...this.getRouteProps('search')}
        />
        <YouTube
          path={`${__webpack_public_path__ || '/'}youtube/:section?/:id?`}
        />
        <Settings
          path={`${__webpack_public_path__ || '/'}settings/:action?`}
          {...this.getRouteProps('settings')}
        />
        <ExternalUrl
          path={`${__webpack_public_path__ || '/'}external/:itemId`}
          {...this.getRouteProps('external-url')}
        />
        <Games
          path={`${__webpack_public_path__ || '/'}games`}
          {...this.getRouteProps('games')}
        />
        <Apps
          path={`${__webpack_public_path__ || '/'}apps`}
          {...this.getRouteProps('apps')}
        />
        <RadiosApp
          path={`${__webpack_public_path__ || '/'}radios`}
          {...this.getRouteProps('radios')}
        />

      </Router>
    )
  }
}

export default withGTM(AppRouting)
